import { View, ButtonView } from "@gaming/srvg-classes-core";

export class CompetitionTimelineView extends View {

    chunkButtons : any;

    constructor( options ) {
        options = options || {};
        super( options );
        this.chunkButtons = {};
    }

    /**
     * Called by parent view if this view is loaded into the DOM
     */
    handleDomInstantiated() {
        super.handleDomInstantiated();

        var chunkKeys = Object.keys(srvg.chunks),
            chunk,
            chunkName,
            button,
            flagCompetitionStageType,
            flagChunkTitleAbbreviation = 0
        ;

        for (var i = 0; i < chunkKeys.length; i++) {
            chunk = srvg.chunks[chunkKeys[i]];

            // First iteration set competitionstage_type_id
            if(i === 0 ) {
                flagCompetitionStageType = chunk['competitionstage_type_id'];
            }

            // Skip iteration if chunk_title_abbreviation is the same
            if(flagChunkTitleAbbreviation === chunk['chunk_title_abbreviation']) {
                continue;
            } else {
                // Update flag for chunk_title_abbreviation
                flagChunkTitleAbbreviation = chunk['chunk_title_abbreviation'];
            }

            if(chunk['chunk_title_abbreviation']) {
                chunkName = chunk['chunk_title_abbreviation'];
                chunkName = __(chunkName);
            }

            // If competitionstage_type_id has been switched show a separator
            if(chunk['competitionstage_type_id'] != flagCompetitionStageType) {
                var separator = new View({
                    template: app.templateEngine.template(View)
                });
                this.addSubView(separator).$domNode.addClass('Separator');
            }

            button = new ButtonView({
                template: app.templateEngine.template(ButtonView)
            });

            this.addSubView(button);
            button.$domNode.html(chunkName);
            this.chunkButtons[chunk.id] = button;

            // Update flag for competitionstage_type_id
            flagCompetitionStageType = chunk['competitionstage_type_id'];
        }
    }


    /**
     * Highlight the actual matchday
     * @param chunkId
     */
    highlightChunkNr( chunkId: number ) {
        var buttonKeys = Object.keys(this.chunkButtons);

        for (var i = 0; i < buttonKeys.length ; i++) {
            this.chunkButtons[buttonKeys[i]].setSelected(false);
        }

        if( this.chunkButtons[chunkId] ) {
            this.chunkButtons[chunkId].setSelected(true);
        } else {
            // If chunk_title_abbreviation was the same only one button was created
            // To highlight this button loop back to the chunkId
            for (var j = chunkId; j > 0 ; j--) {
                if(this.chunkButtons[j]) {
                    this.chunkButtons[j].setSelected(true);
                    return;
                }
            }
        }
    }
}